// components/layouting/common/NestingModal.jsx
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const PRESETS = [
  { value: "split_by_color_space_0", label: "Заказ целиком на листе, отступ 0" },
  { value: "split_by_color_space_1", label: "Заказ целиком на листе, отступ 1" },
  { value: "space_0", label: "Заказ на нескольких листах, отступ 0" },
  { value: "space_1", label: "Заказ на нескольких листах, отступ 1" },
];

export default function NestingModal({ show, onClose, onSubmit, isSubmitting }) {
  const [sheetWidth, setSheetWidth] = useState(825);
  const [sheetHeight, setSheetHeight] = useState(510);
  const [markCountH, setMarkCountH] = useState(4);
  const [markCountV, setMarkCountV] = useState(3);
  const [preset, setPreset] = useState("split_by_color_space_0");

  const reset = () => {
    setSheetWidth(825);
    setSheetHeight(510);
    setMarkCountH(4);
    setMarkCountV(3);
    setPreset("split_by_color_space_0");
  };

  const handleClose = () => {
    if (isSubmitting) return;
    reset();
    onClose();
  };

  const handleSubmit = () => {
    onSubmit({
      Preset: preset,
      SheetWidthMm: sheetWidth,
      SheetHeightMm: sheetHeight,
      MarkCountV: markCountV,
      MarkCountH: markCountH,
    });
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Скомпоновать</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <label className="form-label">Пресет</label>
          <select
            className="form-select"
            value={preset}
            onChange={(e) => setPreset(e.target.value)}
          >
            {PRESETS.map((p) => (
              <option key={p.value} value={p.value}>
                {p.label}
              </option>
            ))}
          </select>
        </div>

        <div className="row g-2 mb-3">
          <div className="col">
            <label className="form-label">Ширина листа (мм)</label>
            <input
              type="number"
              className="form-control"
              value={sheetWidth}
              onChange={(e) => setSheetWidth(parseInt(e.target.value || 0))}
            />
          </div>
          <div className="col">
            <label className="form-label">Высота листа (мм)</label>
            <input
              type="number"
              className="form-control"
              value={sheetHeight}
              onChange={(e) => setSheetHeight(parseInt(e.target.value || 0))}
            />
          </div>
        </div>

        <div className="row g-2">
          <div className="col">
            <label className="form-label">Кол-во меток горизонтально</label>
            <select
              className="form-select"
              value={markCountH}
              onChange={(e) => setMarkCountH(parseInt(e.target.value))}
            >
              {[...Array(9)].map((_, i) => (
                <option key={i + 2} value={i + 2}>
                  {i + 2}
                </option>
              ))}
            </select>
          </div>
          <div className="col">
            <label className="form-label">Кол-во меток вертикально</label>
            <select
              className="form-select"
              value={markCountV}
              onChange={(e) => setMarkCountV(parseInt(e.target.value))}
            >
              {[...Array(9)].map((_, i) => (
                <option key={i + 2} value={i + 2}>
                  {i + 2}
                </option>
              ))}
            </select>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isSubmitting}>
          Отмена
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
          {isSubmitting ? "Компоновка..." : "Скомпоновать"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}